var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVowel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#676fb2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m248.5 0c-16.568 0-30 13.432-30 30v425c0 16.568 13.432 30 30 30s30-13.432 30-30v-425c0-16.568-13.432-30-30-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.356 451.995-42.5-73.612c-8.284-14.349-26.632-19.265-40.981-10.981s-19.265 26.632-10.981 40.981l42.5 73.612c8.284 14.349 26.632 19.265 40.981 10.981s19.265-26.632 10.981-40.981z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.125 367.402c-14.349-8.284-32.697-3.368-40.981 10.981l-42.5 73.612c-8.284 14.349-3.368 32.697 10.981 40.981s32.697 3.368 40.981-10.981l42.5-73.612c8.284-14.349 3.368-32.697-10.981-40.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m438.5 52.5c-11.459 0-369.584 0-378.5 0-33.137 0-60 26.863-60 60v247c0 33.137 26.863 60 60 60h378.5c33.137 0 58.5-26.863 58.5-60v-247c0-33.137-25.363-60-58.5-60z",
    fill: "#53a3ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.5 319.5v-147c0-66.274 53.726-120 120-120-72.735 0-167.387 0-173.5 0-33.137 0-60 26.863-60 60v247c0 33.137 26.863 60 60 60h173.5c-66.274 0-120-33.726-120-100z",
    fill: "#4293dd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60 112.5h378.5v247h-378.5z",
    fill: "#efedff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.558 112.5h-69.558v247h61.297c-5.033-11.657-7.797-24.991-7.797-40v-147c0-21.858 5.847-42.349 16.058-60z",
    fill: "#d4d4ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.435,
    cy: 202.063,
    fill: "#ff8e9e",
    rx: 28.435,
    ry: 22.645
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.565,
    cy: 202.063,
    fill: "#ff8e9e",
    rx: 28.435,
    ry: 22.645
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#313d40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m186.051 162.06c-4.143 0-7.5 3.357-7.5 7.5v12c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-12c0-4.143-3.358-7.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.948 162.06c-4.143 0-7.5 3.357-7.5 7.5v12c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-12c0-4.143-3.357-7.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.892 175.549c-3.123-2.722-7.86-2.396-10.582.727-2.729 3.132-6.669 4.928-10.81 4.928s-8.08-1.796-10.81-4.928c-2.723-3.122-7.46-3.447-10.582-.727-3.123 2.722-3.447 7.46-.727 10.582 5.579 6.401 13.641 10.072 22.118 10.072 8.478 0 16.539-3.671 22.118-10.072 2.722-3.122 2.398-7.86-.725-10.582z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m135 207c-3.046 0-5.662 1.818-6.836 4.426-4.563-2.805-9.927-4.426-15.664-4.426-16.542 0-30 13.458-30 30s13.458 30 30 30c5.737 0 11.101-1.621 15.664-4.426 1.175 2.607 3.79 4.426 6.836 4.426 4.143 0 7.5-3.357 7.5-7.5v-45c0-4.143-3.357-7.5-7.5-7.5zm-22.5 45c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z",
    fill: "#4293dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.837 274.768c-16.583 0-30 13.417-30 30 0 8.014 3.12 15.547 8.786 21.214 5.667 5.666 13.2 8.786 21.214 8.786h8c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-8c-4.007 0-7.773-1.561-10.606-4.394-.941-.94-1.742-1.984-2.392-3.106h35.498c4.143 0 7.5-3.357 7.5-7.5 0-16.581-13.418-30-30-30zm-12.998 22.5c2.574-4.447 7.392-7.5 12.998-7.5 5.531 0 10.386 2.989 12.997 7.5z",
    fill: "#ea5b70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.173 248.25c-4.143 0-7.5 3.357-7.5 7.5v37.5c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-37.5c0-4.143-3.358-7.5-7.5-7.5z",
    fill: "#00ce8e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.173,
    cy: 233.25,
    fill: "#00ce8e",
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.51 272.268c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zm0 45c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z",
    fill: "#4c5699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.347 239.768c-4.143 0-7.5 3.357-7.5 7.5v22.5c0 8.271-6.729 15-15 15s-15-6.729-15-15v-22.5c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v22.5c0 16.542 13.458 30 30 30s30-13.458 30-30v-22.5c0-4.143-3.358-7.5-7.5-7.5z",
    fill: "#4293dd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVowel);
export default __webpack_public_path__ + "static/media/vowel.ba275559d2ea749285e6fcc59cbbe178.svg";
export { ForwardRef as ReactComponent };